import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Get the base URL from the environment variable set during the build
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api/v1";

// Create the root URL for the backend
const BACKEND_ROOT_URL = API_BASE_URL.replace('/api/v1', '');

/**
 * Constructs the full absolute URL for a static asset from its relative path.
 */
export function getFullImageUrl(relativePath: string | null | undefined): string | undefined {
  if (!relativePath) {
    return undefined;
  }

  // If the path is already a full URL, return it directly.
  // This handles cases where the database might store an external link
  // or if the path is a local asset from an import (like the default hero banners).
  if (relativePath.startsWith('http') || relativePath.startsWith('/assets/')) {
    return relativePath;
  }
  
  const cleanRelativePath = relativePath.startsWith('/') ? relativePath.substring(1) : relativePath;

  return `${BACKEND_ROOT_URL}/static/${cleanRelativePath}`;
}
